import i18next from 'i18next';
import { default as React, Suspense, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { compose, createStore } from 'redux';
import Thunk from 'redux-thunk';
import { BaseContainer, appWillMount } from '../base/app';
import { DialogContainer } from '../base/dialog';
import { MiddlewareRegistry, ReducerRegistry, StateListenerRegistry } from '../base/redux';
import { GlobalStateProvider } from './GlobalStateProvider';
import Loading from '../base/loading/Loading';
import AppErrorBoundary from '../base/app/AppErrorBoundary';
function _createStore() {
    const reducer = ReducerRegistry.combineReducers({});
    const middleware = MiddlewareRegistry.applyMiddleware(Thunk);
    const composeEnhancers = compose;
    const store = createStore(reducer, composeEnhancers(middleware));
    StateListenerRegistry.subscribe(store);
    if (typeof APP !== 'undefined') {
        APP.store = store;
    }
    return store;
}
let store = null;
const AppContainer = React.memo(() => {
    const queryClient = new QueryClient();
    store = _createStore();
    store.dispatch(appWillMount(true));
    const isIpad = /iPad/.test(window.navigator.userAgent) ||
        (window.navigator.userAgent.includes('Macintosh') && !/iPhone/.test(window.navigator.userAgent) && 'ontouchend' in document);
    useEffect(() => {
        if (isIpad) {
            document.documentElement.style.touchAction = 'none'; // html tag
            document.body.style.touchAction = 'none'; // body tag
            const root = document.getElementById('root');
            if (root)
                root.style.touchAction = 'none'; // #root
        }
    }, [isIpad]);
    return (React.createElement(I18nextProvider, { i18n: i18next },
        React.createElement(Provider, { store: store },
            React.createElement(AppErrorBoundary, null,
                React.createElement(Suspense, { fallback: React.createElement(Loading, { isLoad: true }) },
                    React.createElement(QueryClientProvider, { client: queryClient },
                        React.createElement(GlobalStateProvider, null,
                            React.createElement(BaseContainer, null),
                            React.createElement(DialogContainer, null),
                            React.createElement(Loading, null))))))));
});
export default AppContainer;
